import { BASE_FONT_SIZE } from '@styles/constants';

export const getScreenHeight = (): number =>
  (window.innerHeight ?? document.documentElement.clientHeight) / BASE_FONT_SIZE;
